import {
    DoubleArrowLeftIcon,
    DoubleArrowRightIcon,
} from '@radix-ui/react-icons';
import { useMediaRemote, useMediaState } from '@vidstack/react';
import { useTranslation } from 'react-i18next';
import { PlayerIconButton } from './SmartPlayerUI';

export const SmartPlayerSkip = ({
    direction,
    seconds = 10,
}: {
    direction: 'forward' | 'backward';
    seconds?: number;
}) => {
    const { t } = useTranslation('smartPlayer');
    const remote = useMediaRemote();
    const currentTime = useMediaState('currentTime');

    const handleSkip = (e: React.MouseEvent) => {
        e.stopPropagation();
        remote.seek(
            direction === 'forward'
                ? currentTime + seconds
                : currentTime - seconds,
        );
    };

    return (
        <PlayerIconButton
            onClick={handleSkip}
            title={
                direction === 'forward'
                    ? t('controls.skip_forward', { seconds })
                    : t('controls.skip_backward', { seconds })
            }
        >
            {direction === 'forward' ? (
                <DoubleArrowRightIcon width='18' height='18' />
            ) : (
                <DoubleArrowLeftIcon width='18' height='18' />
            )}
        </PlayerIconButton>
    );
};
